var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container",class:{ show: _vm.isLoading },attrs:{"role":"alert","aria-live":"assertive","id":_vm.uuid}},[_c('div',{staticClass:"loader"},[_vm._v("Loading...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86f86d1e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/aha-loading-spinner.vue
// module id = 799
// module chunks = 0